export default namespace => type => `${namespace}/${type}`
